export default __webpack_public_path__ + "static/media/create-project.5e5eeee2.png";